import * as actionTypes from './actionTypes';
import * as baseAction from './baseAction';

import { sanitizePhoneNumber } from '../../lib/Sanitizer';
import { formatPhoneNumber } from '../../lib/Formatter';

export const officeStart = (accessToken, data) => baseAction.actionStart(actionTypes.OFFICE_START, accessToken, data);
export const officeSuccess = (data) => baseAction.actionSuccess(actionTypes.OFFICE_SUCCESS, data);
export const officeFail = (error) => baseAction.actionFail(actionTypes.OFFICE_FAIL, error);

export const officeSelect = (options) => {
  return (dispatch, getState) => {
    if (options && options.officeId) {
      baseAction.actionExecute(dispatch, getState, {
        url: `/BranchOffice/${options.officeId}`,
        startFn: (accessToken) => dispatch(officeStart(accessToken, { lastScope: 'select' })),
        successFn: (response) => dispatch(officeSuccess({ office: formatData(response.data), isNew: false })),
        failFn: (error) => dispatch(officeFail(error))
      });
    } else {
      dispatch(officeSuccess({ office: null, isNew: true }));
    }
  };
};

export const officeList = (options) => {
  return (dispatch, getState) => {    
    let url = '/BranchOffice';
    
    if (options) {
      if (options.franchiseId) { url += `/Franchise/${options.franchiseId}`; }
    }
        
    baseAction.actionExecute(dispatch, getState, {
      url: url,
      startFn: (accessToken) => dispatch(officeStart(accessToken, { lastScope: 'list' })),
      successFn: (response) => dispatch(officeSuccess({ offices: response.data })),
      failFn: (error) => dispatch(officeFail(error))
    });
  };
};

export const officeCreate = (options) => {
  return (dispatch, getState) => {
    let url = '/BranchOffice';
    if (options.franchiseId) { url += `/Franchise/${options.franchiseId}`; }  

    baseAction.actionExecute(dispatch, getState, {
      type: 'create',
      url: url,
      payload: sanitizeData(options.data),
      startFn: (accessToken) => dispatch(officeStart(accessToken, { lastScope: 'create' })),
      successFn: (response) => dispatch(officeSuccess({ office: formatData(response.data), isNew: false })),
      failFn: (error) => dispatch(officeFail(error))
    });
  };
};

export const officeUpdate = (options) => {  
  return (dispatch, getState) => {
    baseAction.actionExecute(dispatch, getState, {
      type: 'update',
      url: `/BranchOffice/${options.officeId}`,
      payload: sanitizeData(options.data),
      startFn: (accessToken) => dispatch(officeStart(accessToken, { lastScope: 'update' })),
      successFn: (response) => dispatch(officeSuccess({ office: formatData(response.data), isNew: false })),
      failFn: (error) => dispatch(officeFail(error))
    });
  };
};

export const officeDelete = (options) => {
  return (dispatch, getState) => {
    baseAction.actionExecute(dispatch, getState, {
      type: 'delete',
      url: `/BranchOffice/${options.officeId}`,
      startFn: (accessToken) => dispatch(officeStart(accessToken, { lastScope: 'delete' })),
      successFn: () => dispatch(officeSuccess({ office: null, isNew: false })),
      failFn: (error) => dispatch(officeFail(error))      
    })
  };
};

export const officeGeocode = (options) => {
  return (dispatch, getState) => {
    baseAction.actionExecute(dispatch, getState, {
      type: 'put',
      url: `/BranchOffice/UpdateGeocode/${options.officeId}`,
      startFn: (accessToken) => dispatch(officeStart(accessToken, { lastScope: 'geocode' })),
      successFn: (response) => dispatch(officeSuccess({ office: formatData(response.data), isNew: false })),
      failFn: (error) => dispatch(officeFail(error))      
    })
  };
};

const formatData = (value) => {
  if (value) {
    if (value.primaryPhone) {
      value.primaryPhone = formatPhoneNumber(value.primaryPhone);
    }

    if (value.recruitingPhone) {
      value.recruitingPhone = formatPhoneNumber(value.recruitingPhone);
    }
  }

  return value;
};

const sanitizeData = (value) => {
  if (value) {
    value.primaryPhone = (value.primaryPhone) && sanitizePhoneNumber(value.primaryPhone);
    value.recruitingPhone = (value.recruitingPhone) && sanitizePhoneNumber(value.recruitingPhone);
  }

  return value;
};
